"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var Creatable_1 = __importDefault(require("react-select/lib/Creatable"));
var utils_1 = require("../../../utils");
var Keyboard = __importStar(require("../../Keyboard"));
var Dropdown = function (props) {
    var _a = (0, react_1.useState)([]), options = _a[0], setOptions = _a[1];
    var _b = (0, react_1.useState)(), selectedOption = _b[0], setSelectedOption = _b[1];
    (0, react_1.useEffect)(function () {
        if (props.options) {
            setOptions(props.options.map(function (x) { return ({ value: x.value || x.label, label: x.label }); }));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (!props.buttonText) {
            sendChoice();
        }
    }, [selectedOption]);
    var sendChoice = function () {
        if (!selectedOption) {
            return;
        }
        var label = selectedOption.label, value = selectedOption.value;
        if (selectedOption.length) {
            label = selectedOption.map(function (x) { return x.label; }).join(',');
            value = selectedOption.map(function (x) { return x.value || x.label; }).join(',');
        }
        props.onSendData && props.onSendData({ type: 'quick_reply', text: label, payload: value || label });
    };
    var renderSelect = function (inKeyboard) {
        return (react_1.default.createElement("div", { className: (inKeyboard && 'bpw-keyboard-quick_reply-dropdown') || 'bpw-in-message-quick_reply-dropdown' },
            react_1.default.createElement("div", { style: { width: props.width || '100%', display: 'inline-block' } }, props.allowCreation ? (react_1.default.createElement(Creatable_1.default, { value: selectedOption, onChange: setSelectedOption, options: options, placeholder: props.placeholderText, isMulti: props.allowMultiple, menuPlacement: 'top' })) : (react_1.default.createElement(react_select_1.default, { value: selectedOption, onChange: setSelectedOption, options: options, placeholder: props.placeholderText, isMulti: props.allowMultiple, menuPlacement: 'top' }))),
            props.buttonText && (react_1.default.createElement("button", { className: "bpw-button", onClick: sendChoice }, props.buttonText))));
    };
    var shouldDisplay = props.isLastGroup && props.isLastOfGroup;
    var message;
    if (props.markdown) {
        var html = (0, utils_1.renderUnsafeHTML)(props.message, props.escapeHTML);
        message = react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: html } });
    }
    else {
        message = react_1.default.createElement("p", null, props.message);
    }
    if (props.displayInKeyboard && Keyboard.Default.isReady()) {
        return (react_1.default.createElement(Keyboard.Prepend, { keyboard: renderSelect(true), visible: shouldDisplay }, message));
    }
    return (react_1.default.createElement("div", null,
        message,
        shouldDisplay && renderSelect(false)));
};
exports.Dropdown = Dropdown;
